module.exports = __webpack_public_path__ + "static/img/dy1-6.bb6d65a.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/dy1-6.png
// module id = 946
// module chunks = 0